import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Alert } from '@zooplus/ui-components';
import CreditCard from '../../../CreditCard/CreditCard.js';
import BaseModal from '../BaseModal/BaseModal.js';
import styles from '../BaseModal/BaseModal.module.scss.js';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useCreditcardService } from '../../../../providers/CreditCardsMutationProvider.js';
import { useOverlays, OverlayIds } from '../../../../providers/OverlaysProvider.js';
import { captureException } from '../../../../services/sentryService.js';

/**
 * Modal to make the customer confirms that he really wants to delete the given stored credit card.
 * Independent from the actual payment service provider.
 */
const DeleteCardModal = () => {
    const { t } = useTranslation();
    const { deleteCard, data } = useCreditcardService();
    const [deleteCardError, setDeleteCardError] = useState();
    const [deleteCardLoading, setDeleteCardLoading] = useState(false);
    const { hideOverlay } = useOverlays();
    if (!data.cardToDelete) {
        return null;
    }
    const handleDeleteCard = () => {
        setDeleteCardLoading(true);
        setDeleteCardError(undefined);
        deleteCard()
            .then(() => {
            hideOverlay(OverlayIds.DELETE_CARD);
            setDeleteCardLoading(false);
        })
            .catch((error) => {
            // on any unexpected error, send it to Sentry and display a generic error message to the user
            captureException({ error });
            setDeleteCardError(t('checkout.payment.creditcard.error.deletecard.apicall'));
            setDeleteCardLoading(false);
        });
    };
    return (jsxs(BaseModal, { modalId: OverlayIds.DELETE_CARD, disabledPrimaryBtn: deleteCardLoading, disabledSecondaryBtn: deleteCardLoading, isLoading: deleteCardLoading, handleSubmit: handleDeleteCard, heading: t('checkout.payment.creditcard.delete'), primaryButtonLabel: t('general.button.delete'), headingId: `delete-card-${data.cardToDelete?.pspIdentifier}`, closeBtnAriaLabel: t('checkout.payment.creditcard.delete'), dataZta: "modal-removeCard", size: "sm", children: [deleteCardError && (jsx(Alert, { className: styles.errorMessage, variant: "warning", children: deleteCardError })), jsx("div", { className: styles.confirmDeleteMessage, children: t('checkout.payment.creditcard.delete.confirm') }), jsx("div", { className: styles.confirmDeleteCardContainer, children: data.cardToDelete && jsx(CreditCard, { creditCard: data.cardToDelete, showIcons: false }) })] }));
};

export { DeleteCardModal as default };
//# sourceMappingURL=DeleteCardModal.js.map
